// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__5FLMB","head":"ProcedureTableInfo_head__30Ttc"};